import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface WorkflowGuidanceCardProps {
  highConfidenceCount: number;
  mediumConfidenceCount: number;
  lowConfidenceCount: number;
  onStartFocusedMode: () => void;
  onDismiss?: () => void;
}

export const WorkflowGuidanceCard: React.FC<WorkflowGuidanceCardProps> = ({
  highConfidenceCount,
  mediumConfidenceCount,
  lowConfidenceCount,
  onStartFocusedMode,
  onDismiss
}) => {
  return (
    <Card className="mb-6 border-blue-200 bg-blue-50">
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <h4 className="font-medium text-sm text-blue-900 mb-2">
              🚀 Empfohlener Workflow
            </h4>
            <ol className="text-xs text-blue-800 space-y-1 mb-3">
              <li>
                1. 🎯 Nutze <strong>Focused Mode</strong> für {highConfidenceCount} High-Confidence Transaktionen (2-3 min)
              </li>
              <li>
                2. 📝 Prüfe manuell die {mediumConfidenceCount} "Needs Review" Transaktionen
              </li>
              <li>
                3. ⚠️ Korrigiere {lowConfidenceCount} Fehler und verbessere KI-Lernen
              </li>
            </ol>
            <div className="flex items-center gap-2">
              <Button 
                size="sm" 
                onClick={onStartFocusedMode}
                className="bg-blue-600 hover:bg-blue-700"
                disabled={highConfidenceCount === 0}
              >
                <i className="fa-solid fa-bolt mr-2"></i>
                Focused Mode starten (F)
                {highConfidenceCount > 0 && (
                  <Badge variant="secondary" className="ml-2">
                    {highConfidenceCount}
                  </Badge>
                )}
              </Button>
              {highConfidenceCount === 0 && (
                <span className="text-xs text-blue-600">
                  Keine High-Confidence Transaktionen verfügbar
                </span>
              )}
            </div>
          </div>
          {onDismiss && (
            <button 
              onClick={onDismiss}
              className="text-xs text-blue-600 hover:text-blue-800"
            >
              Ausblenden
            </button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
